import { useDeviceType } from '@cian/ui-kit';

export function useIsDesktop() {
  return useDeviceType() === 'desktop';
}
